import { get, flowRight } from 'lodash';
import { CARD_BORDER_WIDTH_PATH } from '@wix/communities-blog-client-common';
import { connect } from '../components/runtime-context';
// Used in JSDoc
// eslint-disable-next-line no-unused-vars
import { usePostBorderWidth } from '../hooks/use-post-border-width';
import { getAppSettings } from '../selectors/app-settings-base-selectors';
import { getIsMobile } from '../store/basic-params/basic-params-selectors';
import withFeedBorderWidth from './with-feed-border-width';
import withHocName from './with-hoc-name';
import withIsFeedDesignEnabled from './with-is-feed-design-enabled';

const DEFAULT_WIDTH = 1;

const getPostCardBorderWidth = (state) =>
  getIsMobile(state)
    ? DEFAULT_WIDTH
    : get(getAppSettings(state), CARD_BORDER_WIDTH_PATH, DEFAULT_WIDTH);

const mapRuntimeToProps = (
  state,
  { borderWidth: feedBorderWidth, applyFeedDesign },
) => ({
  borderWidth: applyFeedDesign
    ? feedBorderWidth
    : getPostCardBorderWidth(state),
});

const connector = connect(mapRuntimeToProps);

/** @deprecated use {@link usePostBorderWidth} instead */
export default flowRight(
  withFeedBorderWidth,
  withIsFeedDesignEnabled,
  connector,
  withHocName('WithPostBorderWidth'),
);
